import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

type GmailAdViewState = 'closed' | 'open';

/** Performance Max in Gmail (desktop): the collapsed inbox row and the expanded message. */
@Component({
  selector: 'app-pmax-gmail-closed-open-01-desktop',
  imports: [CommonModule, DesktopFrameComponent],
  templateUrl: './gmail-closed-open-01-desktop.component.html',
  styleUrl: './gmail-closed-open-01-desktop.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PmaxGmailClosedOpen01DesktopPreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Which of the ad's two real states is shown: the collapsed inbox row, or the expanded message. */
  view: GmailAdViewState = 'closed';

  /** The uploaded creative matching this set's 1.91:1 landscape format, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }

  /** This placement's creative slot is the 1.91:1 landscape format. */
  readonly creativeFormat: CreativeFormat = 'landscape';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  get headline(): string {
    return this.data.headlines[0] || 'Your headline appears here';
  }

  get description(): string {
    return this.data.descriptions[0] || 'Your description appears here';
  }

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }

  selectView(view: GmailAdViewState): void {
    this.view = view;
  }
}
